import {Spinner} from '../../animation/loading/Spinner';
import React from 'react';
import styled from 'styled-components';

const TabLoadingSpinnerWrapper = styled.div`
    color: var(--unselected-tab-text-color);
    font-weight: 400;
    text-decoration: none;
    display: flex;
    height: 28px;
`;

const LoadingTextWrapper = styled.div`
    padding: 2px 12px 2px 8px;
    line-height: 1.6;
`;

const SpinnerWrapper = styled.div`
    padding: 6px 12px 2px 12px;
    ${Spinner} {
        font-size: 14px;
    }
`;
export const TabLoadingSpinner = ({children}) => (
    <TabLoadingSpinnerWrapper>
        <SpinnerWrapper>
            <Spinner />
        </SpinnerWrapper>
        <LoadingTextWrapper>{children}</LoadingTextWrapper>
    </TabLoadingSpinnerWrapper>
);
